<template>
  <span class="inline-flex min-w-[1.3rem] px-2 py-1 items-center justify-center rounded-full bg-current"><mark class="bg-transparent text-xs tabular-nums text-black"><slot /></mark></span>
</template>
